// removed by extract-text-webpack-plugin
module.exports = {"networkHeading":"styles__networkHeading__1_Cx_","designersImage":"styles__designersImage__1scwr","designersButton":"styles__designersButton__1rOQO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Designers/styles.scss
// module id = 387
// module chunks = 0